import React, {useState} from 'react';
import {Form, Input, Button, Row, Col} from 'antd';
import {useAccountStore} from 'hooks/account-store';

const layout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16},
};

const tailLayout = {
    wrapperCol: {offset: 8, span: 16},
};

export function Login() {
    const accountStore = useAccountStore();
    const [loading, setLoading] = useState(false);
    const [failedLogin, setFailedLogin] = useState(false);

    const onFinish = async (values: object) => {
        const {username, password} = values as { username: string; password: string };
        setLoading(true);
        const loggedIn = await accountStore.login(username, password);
        if (!loggedIn) {
            setFailedLogin(true);
            setLoading(false);
        }
    };

    const handleChange = () => {
        setFailedLogin(false);
    };

    return (
        <Row justify="center" style={{width: '100%'}}>
            <Col style={{margin: 'auto'}}>
                <Form
                    {...layout}
                    onFinish={onFinish}
                    onChange={handleChange}
                >
                    <Form.Item
                        label="Username"
                        name="username"
                        rules={[{required: true}]}
                        validateStatus={failedLogin ? 'error' : ''}
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        label="Password"
                        name="password"
                        rules={[{required: true}]}
                        validateStatus={failedLogin ? 'error' : ''}
                        help={failedLogin ? 'Wrong username or password!' : ''}
                    >
                        <Input.Password/>
                    </Form.Item>

                    <Form.Item {...tailLayout}>
                        <Button
                            type="primary"
                            htmlType="submit"
                            disabled={failedLogin}
                            loading={loading}
                        >
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Col>
        </Row>
    );
}
